import { useTranslation } from 'react-i18next';
import { usePTPConfigContext } from 'GlobalConfig.context';
import { useProgressPreprintedReturnSteps } from '@pperform/pp-react-components/PpProgressIndicatorPreprintedReturn';
import { ReturnShipment } from 'components/MerchantTrackingWidget/components/ReturnShipment/models/ReturnShipment.model';
import { constructPreprintedReturnProgressIndicatorTheme } from 'utils/progressIndicator.utils';
import Shipment from 'interfaces/PmParcel';
import { PpProgressIndicator } from '../models';

export const useProgressPreprintedReturnShipment = (baseShipment: Shipment) => {
  const { t } = useTranslation();
  const configs = usePTPConfigContext();

  const shipment = ReturnShipment.create(baseShipment);
  const progressItemThemes =
    constructPreprintedReturnProgressIndicatorTheme(configs);

  const progressIndicator: PpProgressIndicator =
    useProgressPreprintedReturnSteps({
      progressItemThemes,
      translation: t,
      parcelEvents: shipment.parcel.events,
    });

  const { steps, activeStageIndex, theme } = progressIndicator;

  const activeStage = steps[activeStageIndex] || {};
  const iconTheme = theme.current;

  return {
    steps,
    activeStage,
    activeStageIndex,
    iconTheme,
  };
};
